import React from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./guaranteePopup.module.scss";
import { FiGift } from "react-icons/fi";

const GuaranteePopup: React.FC = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/guarantee");
    };

    return (
        <button
            className={Styles["floatingWrapper"]}
            onClick={handleClick}
            title="View 6-Class Money-Back Guarantee Offer Terms"
            aria-label="View Offer Terms"
        >
            <div className={Styles["shakeLayer"]}>
                <div className={Styles["innerContainer"]}>
                    {/* Flashy Pulsing Rings (staggered for a rippling effect) */}
                    <div className={Styles["pulseRing"]} />
                    <div
                        className={`${Styles["pulseRing"]} ${Styles["pulseRingDelay"]}`}
                    />

                    {/* Magenta Star / Sparkle Icon Decoration */}
                    <div className={Styles["sparkleDecoration"]}>
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            {/* 4-pointed main star line outline */}
                            <path
                                d="M 22 4 C 23 12 26 15 34 16 C 26 17 23 20 22 28 C 21 20 18 17 10 16 C 18 15 21 12 22 4 Z"
                                fill="none"
                                stroke="#e026c9"
                                strokeWidth="3.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            {/* Small sparkle dots */}
                            <circle cx="28" cy="8" r="2.5" fill="#f43f5e" />
                            <circle cx="10" cy="24" r="2.5" fill="#f59e0b" />
                        </svg>
                    </div>

                    {/* Yellow 'Offers' Badge */}
                    <div className={Styles["offersBadge"]}>Offers</div>

                    {/* Vibrant Gradient Gift Circle Button */}
                    <div className={Styles["circleBtn"]}>
                        <span className={Styles["giftIcon"]}>
                            <FiGift />
                        </span>
                    </div>

                    {/* Confetti burst — plays the "unboxing" moment on a loop */}
                    <div className={Styles["confettiBurst"]}>
                        {[
                            { dx: "40px", dy: "0px", color: "#fbbf24" },
                            { dx: "20px", dy: "-35px", color: "#f43f5e" },
                            { dx: "-20px", dy: "-35px", color: "#e026c9" },
                            { dx: "-40px", dy: "0px", color: "#8b5cf6" },
                            { dx: "-20px", dy: "35px", color: "#ffffff" },
                            { dx: "20px", dy: "35px", color: "#f59e0b" },
                        ].map((dot, index) => (
                            <span
                                key={index}
                                className={Styles["confettiDot"]}
                                style={
                                    {
                                        "--dx": dot.dx,
                                        "--dy": dot.dy,
                                        backgroundColor: dot.color,
                                    } as React.CSSProperties
                                }
                            />
                        ))}
                    </div>
                </div>
            </div>
        </button>
    );
};

export default GuaranteePopup;
